import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ABOUT_ERIC_IMAGE, BRAND } from "@/data/site";

const AboutEric = () => {
  return (
    <section className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-7 order-2 lg:order-1"
        >
          <p className="eyebrow mb-6">Mijn visie op fotografie</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-8">
            Tussen <span className="italic text-gold">experiment</span> en emotie.
          </h2>
          <div className="space-y-5 text-neutral-700 leading-relaxed max-w-xl">
            <p>
              Ik ben Eric Lemmens — Lenslopers Fotografie. Autodidact fotograaf, nieuwsgierig naar
              wat er gebeurt wanneer je techniek loslaat en ruimte geeft aan het moment.
            </p>
            <p>
              Ik zoek naar beelden met karakter. Naar echtheid, sfeer en dat kleine moment dat je
              niet kunt regisseren.
            </p>
            <p className="text-ink">
              Maar wie zit er achter Lenslopers? En waarom kijk ik op deze manier naar fotografie?
            </p>
            <p className="font-serif text-xl md:text-2xl italic leading-snug text-ink">
              Ontdek mijn verhaal, mijn visie en de manier waarop ik mijn beelden maak.
            </p>
          </div>
          <div className="mt-10 flex items-end gap-6">
            <span className="font-script text-gold text-5xl leading-none">Eric</span>
            <span className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-2">
              — {BRAND.fullName}
            </span>
          </div>
          <Link to="/over-eric" className="btn-outline-dark mt-10">
            Lees mijn verhaal
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
          className="lg:col-span-5 order-1 lg:order-2"
        >
          <div className="relative aspect-[4/5] overflow-hidden bg-neutral-100">
            <img
              src={ABOUT_ERIC_IMAGE}
              alt="Eric Lemmens — fotograaf"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 border border-gold/40 m-4 pointer-events-none" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutEric;
